/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-profile': {
    width: 10,
    height: 10,
    viewBox: '0 0 10 10',
    data: '<g clip-path="url(#svgicon-icon-profile-a)"><path pid="0" d="M5.001.215a2.644 2.644 0 0 1 2.643 2.643c0 .803-.361 1.52-.926 2.005A4.25 4.25 0 0 1 9.25 8.751v.536a.5.5 0 0 1-1 0v-.536a3.25 3.25 0 0 0-6.501 0v.536a.5.5 0 0 1-1 0v-.536a4.251 4.251 0 0 1 2.531-3.888 2.635 2.635 0 0 1-.924-2.005A2.644 2.644 0 0 1 5.001.215zm0 1a1.644 1.644 0 0 0 0 3.286 1.643 1.643 0 0 0 0-3.286z" _fill="#737373"/></g><defs><clipPath id="svgicon-icon-profile-a"><path pid="1" _fill="#fff" d="M0 0h10v10H0z"/></clipPath></defs>'
  }
})
